import React from "react";
import { useStockOutAndInListModel } from "../stockOutAndInListModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel, { transOptions, getFindItem } from "@/model/globalModel";

export function PageHeader() {
    const {
        initPgCfg,
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useStockOutAndInListModel();
    const { technicianData, shopAndOrg: { shopType }, allShopDs } = useGlobalModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "借件单号",
            fieldName: "borrowCode"
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "借件人",
            fieldName: "borrowPerson",
            allowClear: true,
            options: transOptions(technicianData)
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            placeholder: ["借件日期开始", "借件日期结束"],
            rangePickerFieldName: ["startTime", "endTime"],
            format: "YYYY-MM-DD",
            span: 4,
            xxl: 4,
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     placeholder: "所属站点",
        //     fieldName: "shopId",
        //     options: allShopDs,
        //     disabled: shopType === 0 ? false : true
        // },
    ]
    return (
        <YhPageHeader
            title="维修借件"
            size="small"

            triggerSearch={true}
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={(params) => { loadData(initPgCfg, { ...searchParam, ...params }) }}
            handleReset={resetSearchParam}
        />
    );
}